export function createLogscordApplicationStructuredData(siteUrl, description) {
    return [
        {
            type: "application/ld+json",
            json: {
                "@context": "https://schema.org",
                "@type": "SoftwareApplication",
                name: "LogsCord",
                applicationCategory: "BusinessApplication",
                operatingSystem: "Web",
                url: `${siteUrl.replace(/\/$/, "")}/`,
                description,
            },
        },
    ];
}
//# sourceMappingURL=application.js.map